import 'nprogress/nprogress.css'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from 'src/app/App'
import { SidebarProvider } from 'src/contexts/SidebarContext'
import './i18n' // Import the i18n configuration
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

document.addEventListener('DOMContentLoaded', () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
        <SidebarProvider>
          <App/>
        </SidebarProvider>
      </HelmetProvider>
    </I18nextProvider>
  )
})
